import { Component, OnInit, OnDestroy } from '@angular/core';

import { MainService } from 'app/resources/services/index';

@Component({
  selector: 'app-sac',
  templateUrl: './sac.component.html',
  styleUrls: ['./sac.component.css']
})
export class SacComponent implements OnInit, OnDestroy {

  public processando = false;

  constructor(public mainService: MainService) { }

  ngOnInit() {
    this.mainService.sacService.chamados = undefined;
    window.scrollTo(0, 0);
    this.mainService.sacService.atualizarChamados();
    this.mainService.saldoService.initialize();
  }

  ngOnDestroy() {
    this.mainService.sacService.chamados = undefined;
  }

}



// WEBPACK FOOTER //
// ./src/app/menu-superior/sac/sac.component.ts